import { render } from "./PROPOSAL_RIKSDAGEN_DECISION_CONSOLIDATED.vue?vue&type=template&id=509258f0"
import script from "./PROPOSAL_RIKSDAGEN_DECISION_CONSOLIDATED.vue?vue&type=script&lang=js"
export * from "./PROPOSAL_RIKSDAGEN_DECISION_CONSOLIDATED.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__